import axios from 'axios';
import { SetAuthHeader } from './utils/authHeader';
import { useOktaAuth } from './use-okta-auth';
import { HandleAxiosError } from './utils/axiosError';

let params = {};

const pellaAPI = process.env.GATSBY_PELLA_API;

export const useProject = () => {
	const { authState } = useOktaAuth();
	const accessToken = authState?.accessToken?.accessToken;

	const requestConfig = {
		headers: {
			...SetAuthHeader(accessToken),
		},
		withCredentials: true,
	};

	const getProjects = async () => {
		const userPostalCode = localStorage?.getItem('UserPostalCode');
		try {
			if (userPostalCode) {
				params.client_postal_code = userPostalCode;
			}

			const response = await axios.get(`${pellaAPI}/web-project/api/v1/projects`, { ...requestConfig, params: params });

			return response;
		} catch (error) {
			return HandleAxiosError(error);
		}
	};

	const getProject = async (projectID) => {
		const userPostalCode = localStorage?.getItem('UserPostalCode');
		try {
			if (userPostalCode) {
				params.client_postal_code = userPostalCode;
			}

			const response = await axios.get(`${pellaAPI}/web-project/api/v1/projects/${projectID}`, { ...requestConfig, params: params });

			return response;
		} catch (error) {
			return HandleAxiosError(error);
		}
	};

	const createProject = async (name, description) => {
		const userPostalCode = localStorage?.getItem('UserPostalCode');
		try {
			if (userPostalCode) {
				params.client_postal_code = userPostalCode;
			}

			const data = {
				name,
				description: description !== '' ? description : null,
			};

			const response = await axios.post(`${pellaAPI}/web-ecommerce/api/v1/projects`, data, { ...requestConfig, params: params });

			return response;
		} catch (error) {
			return HandleAxiosError(error);
		}
	};

	const createProjectWithItem = async (name, url, configKey, description) => {
		const userPostalCode = localStorage?.getItem('UserPostalCode');
		try {
			if (userPostalCode) {
				params.client_postal_code = userPostalCode;
			}

			const data = {
				name,
				description: description !== '' ? description : null,
				item: {
					item_url: url,
					config_id: configKey,
				},
			};

			const response = await axios.post(`${pellaAPI}/web-ecommerce/api/v1/projects`, data, { ...requestConfig, params: params });

			return response;
		} catch (error) {
			return HandleAxiosError(error);
		}
	};

	const addItemToProject = async (projectID, groupID, configKey, url) => {
		const userPostalCode = localStorage?.getItem('UserPostalCode');
		try {
			if (userPostalCode) {
				params.client_postal_code = userPostalCode;
			}

			const data = {
				item_url: url,
			};

			const response = await axios.post(`${pellaAPI}/web-ecommerce/api/v1/projects/${projectID}/groups/${groupID}/items/${configKey}`, data, { ...requestConfig, params: params });

			return response;
		} catch (error) {
			return HandleAxiosError(error);
		}
	};

	const updateProjectItem = async (projectID, groupID, itemID, data) => {
		const userPostalCode = localStorage?.getItem('UserPostalCode');
		try {
			if (userPostalCode) {
				params.client_postal_code = userPostalCode;
			}

			const response = await axios.put(`${pellaAPI}/web-ecommerce/api/v1/projects/${projectID}/groups/${groupID}/items/${itemID}`, data, { ...requestConfig, params: params });

			return response;
		} catch (error) {
			return HandleAxiosError(error);
		}
	};

	const deleteProjectItem = async (projectID, groupID, itemID) => {
		const userPostalCode = localStorage?.getItem('UserPostalCode');
		try {
			if (userPostalCode) {
				params.client_postal_code = userPostalCode;
			}

			const response = await axios.delete(`${pellaAPI}/web-ecommerce/api/v1/projects/${projectID}/groups/${groupID}/items/${itemID}`, { ...requestConfig, params: params });

			return response;
		} catch (error) {
			return HandleAxiosError(error);
		}
	};

	const deleteProject = async (projectID) => {
		const userPostalCode = localStorage?.getItem('UserPostalCode');
		try {
			if (userPostalCode) {
				params.client_postal_code = userPostalCode;
			}

			const response = await axios.delete(`${pellaAPI}/web-project/api/v1/projects/${projectID}`, { ...requestConfig, params: params });

			return response;
		} catch (error) {
			return HandleAxiosError(error);
		}
	};

	const updateProject = async (projectID, edits) => {
		const userPostalCode = localStorage?.getItem('UserPostalCode');
		try {
			if (userPostalCode) {
				params.client_postal_code = userPostalCode;
			}

			const response = await axios.patch(`${pellaAPI}/web-project/api/v1/projects/${projectID}`, edits, { ...requestConfig, params: params });

			return response;
		} catch (error) {
			return HandleAxiosError(error);
		}
	};

	const copyProjectItemToQuote = async (projectID, groupID, itemID, data) => {
		const userPostalCode = localStorage?.getItem('UserPostalCode');
		try {
			if (userPostalCode) {
				params.client_postal_code = userPostalCode;
			}

			const response = await axios.post(`${pellaAPI}/web-ecommerce/api/v1/projects/${projectID}/groups/${groupID}/items/${itemID}/copy`, data, { ...requestConfig, params: params });

			return response;
		} catch (error) {
			return HandleAxiosError(error);
		}
	};

	return {
		getProjects,
		getProject,
		createProject,
		createProjectWithItem,
		addItemToProject,
		updateProjectItem,
		deleteProjectItem,
		deleteProject,
		updateProject,
		copyProjectItemToQuote,
	};
};
